<svelte:options customElement="mg-inline-badge" />

<script lang="ts">
    import { fluent } from "@/i18n";

    let { kind }: { kind?: "bot" | "wip" | "beta" } = $props();
</script>

<span
    class={["mg-badge", kind ?? "other"]}
    aria-label={kind ? fluent.format(`badge-${kind}`) : undefined}
    title={kind ? fluent.format(`badge-${kind}`) : undefined}
>
    <slot>
        {fluent.format(`badge-${kind ?? "other"}`)}
    </slot>
</span>

<style lang="scss">
    .mg-badge {
        font-size: 0.8em;
        border-radius: 4px;
        background-color: var(--accentDarken);
        color: var(--bg);
        padding: 0.05em 0.24em;
        vertical-align: text-top;
        line-height: 1.2em;
        margin: 0 0.3em;
        white-space: nowrap;
        user-select: none;
        display: inline-block;
        height: 1.2em;

        & > mg-icon {
            line-height: 1.2;
        }

        &.wip {
            background-color: transparent;
            color: var(--warn);
            border: 1px solid currentColor;
        }

        &.bot {
            background-color: var(--bot-color);
            border: 1px solid var(--bot-color);
        }

        &.beta {
            background-color: transparent;
            color: var(--accent);
            border: solid 1px var(--accent);
        }

        @media all and (prefers-color-scheme: dark) {
            background-color: var(--accentLighten);
        }
    }
</style>
